module.exports = __webpack_public_path__ + "media/images/lb/956-1974414451b831d090c73a85735a4850.svg";